export const SV_DUI_DIGIT_LENGTH = 9
export const SV_DUI_FORMATTED_LENGTH = 10
export const ISO_DATE_FORMATTED_LENGTH = 10

export function compactSvDui(value: string): string {
  return value.replace(/\D/g, '').slice(0, SV_DUI_DIGIT_LENGTH)
}

export function formatSvDui(value: string): string {
  const digits = compactSvDui(value)
  if (digits.length <= 8) return digits
  return `${digits.slice(0, 8)}-${digits.slice(8)}`
}

export function formatIsoDateInput(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 8)
  const groups = [digits.slice(0, 4), digits.slice(4, 6), digits.slice(6, 8)]
  return groups.filter(Boolean).join('-')
}

export function isCompleteIsoDate(value: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false
  const [year, month, day] = value.split('-').map(Number)
  if (!year || !month || !day) return false
  const parsed = new Date(Date.UTC(year, month - 1, day))
  return (
    parsed.getUTCFullYear() === year &&
    parsed.getUTCMonth() === month - 1 &&
    parsed.getUTCDate() === day
  )
}

export function normalizeLegalEntityName(value: string): string {
  return value.replace(/\s+/g, ' ').trimStart().toLocaleUpperCase('es-SV')
}
